import React from "react";
import StoreItem from "./StoreItem";

const StoresList = ({history, storesList}) => {
  return (
    <>
      {storesList.map((store, index) => (
        <StoreItem 
          store={store}
          key={index}
          history={history}
        />
      ))}
    </>
  );
};

export default StoresList;
